<div class="static-container">
  <h4>
    Terms And Conditions
  </h4>

  <div class="mb-5">
    <p class="gray-text">
      This Terms and Conditions (“T&amp;C”) between and among you and DJ MIXING LAB LLC aka DML (“DML”) stating the terms
      that govern your (i.e., customer, registered user, website visitor, DJ, etc.) use of the
      <a routerLink="/">DJMIXINGLAB.com</a> (the
      “Website”), including it’s music store, blog, products and services located at the Website.
    </p>
    <p class="gray-text">
      By using the Website, you agree to and are bound by this T&amp;C. You must accept and abide by this T&amp;C as presented
      to you, and DML reserves the right to change, add, or remove portions of this T&amp;C at anytime. It is your
      responsibility to check the T&amp;C each time before using the Website, and your continued use of the Website will
      indicate your acceptance of any changes. In addition, you agree to comply with all local, state, federal,
      national, and international laws, statutes, ordinances, and regulations that apply to your use of the Website or
      Content (defined below).
    </p>
  </div>
  <ol>
    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>Account Registration.</strong>
        </li>
      </p>
      <p class="gray-text">
        To use certain services of the Website you must register and provide certain information (e.g. a username,
        password, billing information, and valid email address (“Registration Data”) to for the purposes of creating
        your Account. You agree to provide current, complete, and accurate Registration Data at the time you
        register and you will update your Registration Data as necessary to keep it current, complete and accurate.
        The Registration Data will apply to all sections of the Website and act as your username and Registration
        Data for access, rating, communicating, subscribing, purchasing and streaming to all sections of the
        Website. DML may terminate your Account, Subscription and any or all rights to the Website if any
        information you provide is inaccurate, false, incomplete, or, if DML, in its own discretion, suspects
        fraudulent and/or illegal behavior, such as but not limited to identify theft or stolen credit cards or
        artificial purchasing, associated with your registration. You agree that DML may store and use the
        Registration Data you provide for use in billing fees to your credit card and maintaining your Account.
      </p>
      <p class="gray-text">
        You are solely responsible for maintaining the confidentiality and security of your Account. You agree to
        notify DML immediately of any unauthorized use of your password and/or Account. DML shall not be responsible
        for any losses arising out of the unauthorized use of your Registration Data or Account, and you agree to
        hold harmless and to indemnify DML, its partners, parents, subsidiaries, agents, affiliates and/or
        licensors, as applicable, for any improper, unauthorized or illegal uses of your Account. You may not
        attempt to gain unauthorized access to the Website. Should you attempt to do so, assist others in making
        such attempts, or distributing instructions, software or tools for that purpose, DML shall have the right to
        terminate your Account and pursue all available remedies at law.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Content and Products.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        All “Content”, including but not limited to digital downloads of sound recordings, streamed sound recordings
        and related digital content, including songs, mixes and loops, downloads or samples, and all software,
        artwork, graphics, video, text, editorials and news, interfaces, trademarks, logos, images, photographs, and
        any other element of the Website, including the layout, look and feel, organization, and coordination of
        such Content on the Website is the property of or is licensed to DML, and is protected by U.S. and
        international trademark, trade dress, copyright, and other intellectual property rights laws. Without the
        prior written consent of DML or the applicable copyright holder, and except as provided in this T&amp;C, no
        Content may be transmitted, distributed, translated, publicly displayed, uploaded, published, recorded,
        retransmitted, rented, sold, distributed, digitized, endorsed, reproduced, altered to make new works,
        performed, or compiled in any commercial way. Certain Contents are made available by DML for streaming,
        purchase and/or download. The Content is only for your promotional use only. You cannot use the Content for
        sale, commercial or other purposes.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Consent to Our Communication with You by Email.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        By establishing an Account, you grant permission for DML to contact you at your provided e-mail address as
        well as through any of your social media accounts (Facebook, Twitter, Instagram, etc.).
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Community and Brand Features / Public Areas.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        The Website may contain features designed to help users, DJs, labels or brands (collectively a “user” or
        “users”) find and/or exploit Content of personal interest by creating landing pages, pubic profiles,
        generating short URLs and/or viewing Content that other users or artists have sampled, streamed, uploaded
        and/or downloaded. These features may include access to a user’s most recently played list and access to a
        user’s collection of Content. Further, DML may feature message boards, comment areas, and/or chat rooms that
        allow for communication and posting of public profiles between users of the Website.
      </p>

      <p class="gray-text">
        DML HAS THE RIGHT, BUT NOT THE OBLIGATION, TO MONITOR, EDIT, OR REMOVE ANY ACTIVITY OR CONTENT IN SUCH
        PUBLIC AREAS, OR TO RESTRICT ACCESS TO OTHER MEMBERS TO VIEW YOUR MUSIC, CONTENT COLLECTION OR PUBLIC
        PROFILES.
      </p>

      <p class="gray-text">
        DML is not responsible and assumes no liability for any activity, content, messages and the like that you or
        any other user posts to a public area or a public profile, or send to another user.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Age Requirement.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        In order to use the Website, you need to (a) be 18 or older, or be 13 or older and have your parent or
        guardian’s consent to the terms of this T&amp;C, and (b) have the power to enter a binding contract with us and
        are not barred from doing so under any applicable laws. If there are parts of this Website or services being
        offered on the Website where you need to register and provide certain information to DML: You must be at
        least 18 years of age. If you are at least 13 years of age, but under 18 years of age, you must present this
        T&amp;C to your parent or legal guardian, and he or she must click “AGREE” or “JOIN NOW,” as may be applicable,
        to enter into this T&amp;C on your behalf. Children under 13 years of age may not register for the Website, nor
        may parents or legal guardians register on their behalf. If you are a parent or legal guardian entering this
        T&amp;C for the benefit of your child or a child in your legal care, be aware that you are fully responsible for
        the child’s use of the Website, including all financial charges and legal liability that he or she may
        incur.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            System Requirements for Usage.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        You are responsible for any hardware, systems and/or software program(s) you use and any associated fees and
        expenses (a) to connect to, browse or otherwise use the Internet, and/or (b) to access the Website, and/or
        (c) to browse, stream, download, upload, play back, or transfer the Content. You may not attempt, nor
        support others’ attempts, to decrypt, reverse engineer, circumvent or otherwise alter or interfere with any
        software required for use of the Website or Content. If you access the Website over mobile or via an IOS or
        Android application, data charges may apply.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Objectionable Material.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        When using the Website, you understand that you may encounter Content that may be deemed objectionable,
        indecent, or offensive, which content may or may not be identified as having explicit language or text,
        graphic designs, and/or photographs. You agree to use the Website at your own risk and DML shall have no
        liability to you for Content that may be found objectionable, indecent, or offensive.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Charges and Billing.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        You agree to pay for all for-fee Products and Subscriptions that you purchase through the Website. DML may
        charge your credit card for any Products purchased and Subscriptions for any additional amounts (including
        any taxes and late fees, as applicable) as may be accrued by or in connection with your Account. You hereby
        agree to authorize DML to charge your credit card for the above mentioned at DML’s convenience, but within
        (30) days of credit card authorization, but no earlier than the purchased Product is available for actual
        download or delivery, unless as may be required to process pre-order purchases at your request. YOU ARE
        RESPONSIBLE FOR PROVIDING DML WITH A VALID CREDIT CARD AND THE TIMELY PAYMENT OF ALL FEES. At its
        discretion, DML may post charges individually or aggregate your charges with other purchases you make on the
        Website. If any of your billing information changes, you are responsible for updating the information in the
        applicable section of your Account. You are responsible for any charges on your Account that are incurred by
        any person through your Account, regardless of whether you authorized such purchase or not. You are solely
        responsible for keeping your Account secure and confidential.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Limitation on Sales.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        DML reserves the right to refuse access to the Website, sale of Products, stream music, Subscription for any
        reason to any end user. DML may terminate any offers for free or special promotions or pricing on
        merchandise at any time.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Right to Change Prices and Content Availability.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        Prices and availability of Content offered through the Website are subject to change at any time. DML does
        not provide price protection or refunds in the event of a price drop or promotional offering.
      </p>

      <p class="gray-text">
        The monthly fees for Subscriptions are posted on the Website. DML, in its sole discretion, reserves the
        right to modify the fees from time to time.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Payment and Refund Policy.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        Payments for Subscriptions are billed in advance on a monthly basis. If you intend to cancel a subscription,
        you must do so before the next billing period. Please take note that you will be billed for the current
        monthly period, and the cancellation will apply to the next billing period.
      </p>

      <p class="gray-text">
        The Subscription Fees for quarterly &amp; yearly plans are offered at discounted prices. In paying for any of
        these plans, you agree that these fees are not refundable and you therefore unconditionally subscribe for
        these periods.
      </p>

      <p class="gray-text">
        For purchased Products, DML can provide a refund within 30 days from the date of purchase provided that the
        Product is unworn and returned in its new conditional. Refunds will be only approved under the acknowledged
        situations. If a purchase exceeds this period of time, no refund is going to be approved.
      </p>

      <p class="gray-text">
        If you request a refund due to technical problems, we will do our best to solve your problems. No refund is
        available if you refuse to provide detailed information about the error (requested by our support team) such
        as screenshots of error messages, log files, detailed descriptions of your actions, file samples, etc.
      </p>
    </div>


    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            No Responsibility for Typographical Errors.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        Due to the rapidly expanding, broad selection of Content on the Website, it is possible that there maybe
        mistakes in the price, description and picture representing the Content. In such an event, DML reserves the
        right not to accept end user orders based upon typographical errors.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Taxes.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        You are responsible for paying any governmental taxes imposed on your purchases, including, but not limited
        to, sales, use or value-added taxes.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Order Acceptance Policy.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        Your receipt of an electronic or other form of confirmation does not (1) constitute DML’s offer to sell or
        (2) convey DML’s acceptance of your order. DML reserves the right, at its discretion, and without prior
        notice to you, and for any reason, to decline your request for Product(s), or supply less than the quantity
        you ordered following receipt of your order.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Charges and Billing.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        DML currently accepts credit cards, coupon and redemption codes. DML reserves the right to change this
        policy at any time. You agree to pay all fees and charges associated with your purchase(s) (including any
        applicable taxes), at the rates in effect when the charges were incurred. You, not DML, are responsible for
        any unauthorized amounts billed to your credit card by a third party. As a cardholder, your card issuer
        agreement governs your use of the designated card, and as such, you must refer to that agreement to
        determine your rights and liabilities as a cardholder. Obligation to pay for Subscription and Product orders
        previously accepted by DML will survive your termination of your Account.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Limitations of Content Usage and Copyright.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        DML may make available certain Content. Your access to and/or use of any Content will be limited by the
        rules assigned to the Content by DML (“Content Rules”) and described in this T&amp;C or on the Webpage where you
        acquire access to such Content. You may not attempt, nor support others attempts, to decrypt, reverse
        engineer, circumvent or otherwise alter or interfere with any software required for use of the Website or
        any of the Content Rules. DML RESERVES THE RIGHT TO ENFORCE THE PRODUCT RULES WITH OR WITHOUT NOTICE TO YOU.
      </p>
      <p class="gray-text">
        Except as otherwise provided herein, you may not copy, reproduce, modify, rent, lease, broadcast, download,
        transmit, distribute or otherwise disseminate any Downloads or other Content contained on the Website except
        for your own promotional use. Any copying, distribution, use or sharing is not permitted by this T&amp;C or
        applicable provisions of the United States Copyright Code, and is in violation of U.S. and international
        copyright and intellectual property laws.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Prohibited Uses of Content.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        You may not reverse engineer, decompile, disassemble, modify or disable any copy protection or use
        limitation systems associated with the Downloads. You may not play and then re-digitize any Downloads. You
        may not create any “derivative works” by altering any of the Content, except as permitted herein. You may
        not use the Downloads in conjunction with any other third-party content (e.g., to provide sound for a film)
        unless you obtain such rights from the copyright holder. YOU MAY NOT UPLOAD DOWNLOADS, STREAMS OR PREVIEWS
        TO THE INTERNET. PEER-2-PEER FILE SHARING IS STRICTLY PROHIBITED. Any other manner of network file sharing
        and transfer of Downloads to devices for such purpose is expressly prohibited and is a violation of U.S. and
        international copyright law.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Loss of Rights by DML.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        DML may at any time lose the right to make certain Content available. In such an event, you will no longer
        be able to access such Content from the Website.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            DML Username and Subscription Policy.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        No two users or DJs can have the same DML Username or use the same Subscription at anytime. DML Usernames
        are provided on a first-come basis.
      </p>

      <p class="gray-text">
        DML will not typically intervene in DML Username disputes. Disputes should be resolved between the parties.
        However, DML reserves the right, in its sole discretion, to permanently remove, reassign, or ask a user or
        DJ to modify his/her DML Username in situations where:
      </p>
      <ul class="gray-text my-4">
        <li>
          an account has been inactive for a period of time;
        </li>
        <li>
          DML determines that a DML Username is offensive, commercial in nature, violative of, or a derivation of,
          a third party’s trademark or service mark, or is determined by DML to be otherwise misleading;
        </li>
        <li>
          DML suspects that a DML Username is being squatted;
        </li>
        <li>
          DML has determined, in its own discretion, the situation is such that removing or reassigning the DML
          Username is most appropriate under the circumstances. Any attempts to sell, buy, or solicit other forms
          of payment in exchange for a DML Username or Subscription is strictly prohibited and may result in
          permanent account suspension.
        </li>
      </ul>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            User Generated Content.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        DML may permit users to post or submit content, including mixes, tracks, playlist compilations,
        performances, videos, pictures, messages, texts, logos, and other content made available by individual
        artists, labels, brands, and/or users for the purpose of sharing with DML users via streaming or otherwise
        (“User Content”). You are solely responsible for any User Content you may provide and for any consequence
        thereof. By uploading User Content, you represent and warrant that (i) you own or otherwise control all
        applicable rights to the User Content, (ii) have the necessary rights to post, upload, transmit or display
        the User Content on DML, and (iii) that such User Content, or its use as contemplated by this T&amp;C, does not:
        (a) violate this T&amp;C, applicable law, or the intellectual property or publicity rights of others; (b) imply
        an affiliation, endorsement, approval or cooperation with you or your User Content by DML or any unwilling,
        or unknowing, third-party, without that party’s express written consent, or (c) cause injury to any person
        or entity. You agree to defend indemnify and hold harmless DML, its partners, parents, subsidiaries, agents,
        affiliates and/or licensors, as applicable, for all claims resulting from User Content. You agree that any
        loss or damage of any kind that occurs as a result of the use of any User Content you upload, post,
        transmit, display or otherwise make available through your use of the Website is solely your responsibility.
        The rights granted herein shall inure for so long as the User Content is provided by you on the DML Website.
        Except from those rights specifically granted by herein, you shall retain ownership of all rights, including
        intellectual property rights, in the User Content that you post on DML. You acknowledge that no payments
        shall be made to you for the User Content, except as provided for in this agreement or as may be provided
        under a separate T&amp;C between you and DML. DML reserves the right to remove any User Content, for any reason
        or no reason at all, including, but not limited to, copyright violations, derogatory or offensive content,
        User Content that is deemed to be a third-party advertisement or promotional in nature, or User Content that
        violates this T&amp;C. DML reserves the right to terminate the user account and DJ profile of users who are
        repeat offenders of this copyright policy. DML does not monitor, review, edit, or endorse User Content.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Suggestions and Other Submissions.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        Any feedback, suggestions, ideas, videos, stories, or other similar submissions (“Ideas”) disclosed,
        submitted, or offered to shall be the exclusive property of DML. You agree that unless otherwise prohibited
        by law, DML may use, sell, exploit and disclose the Ideas in any manner, without restriction and without
        compensation to you.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Restrictions.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        You may not use the Website (or any part of it, including but not limited to public areas) to upload, post,
        transmit, display, perform or otherwise make available any messages, content or materials (i) that are
        illegal, obscene, threatening, of a “spamming” nature, defamatory, or invasive of privacy; (ii) violate
        (intentionally or unintentionally) a contractual, fiduciary or confidentiality obligation or duty you have
        to any third party; (iii) that constitute political campaigning or commercial solicitation or that contain
        software viruses or other computer code designed to interfere with the functionality of any computer system;
        (iv) provide links to unapproved third party sites; or (v) that infringe third-party rights or harm minors
        in any way. You may not interfere with or disrupt the Website or any networks connected to or by the
        Website. In addition, you may not use a false email address or otherwise mislead other users as to your
        identity or the origin of a message or content.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            DML’s Rights.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        By posting messages, inputting data, or engaging in any other form of communication through the Website, you
        agree that DML may copy, sub-license, adapt, transmit, publicly perform or display any such Content to
        provide and/or promote the Website and/or to respond to any legal requirement, claim or threat. If DML’s use
        of such Content exploits any proprietary rights you may have in such material, you agree that DML has an
        unrestricted, royalty-free, non-exclusive and perpetual worldwide right to do so.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Privacy.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        For additional information regarding DML’s use of information collected in connection with the Website,
        please refer to DML’s Privacy and Cookie Policy, which is incorporated into these Terms and Conditions for
        reference:
        <a routerLink="/privacy-policy">
          Privacy Policy
        </a>
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Copyrights.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        All copyrights in and to the Website, including, but not limited to, (including the compilation of content,
        postings, links to other Internet resources, and descriptions of those resources), and software, are owned
        by DML and/or its licensors. The use of the Website, or any Content on the Website, except for use as
        expressly permitted in this T&amp;C, is prohibited and subject to civil and criminal penalties, including
        possible monetary damages, for copyright infringement. All rights not expressly granted to you in this T&amp;C
        are reserved to DML and/or is licensors.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Trademarks.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        All trademarks, service marks, trade names, slogans, logos, and other indicia of origin that appear on or in
        connection with the Website are the property of DML and/or its affiliates or licensors. You may not copy,
        display or use any of these marks without prior written permission of the mark owner.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Violation of Intellectual Property Rights.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        This service respects copyright. All rights of the authors of the works protected, reproduced and
        communicated on this Website are reserved. Unless authorized, any use of the works other than for the
        purpose of individual and private reproduction and use is prohibited.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Violation of Intellectual Property Rights.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        If DML receives a notice alleging that you have engaged in behavior that infringes DML’s or any other’s
        intellectual property rights or reasonably suspects the same, DML may suspend or terminate your Account
        without notice to you, and shall have no liabilities to you, past or present, for suspension or termination
        under this paragraph. We take alleged copyright infringement seriously. If you believe that any information
        or material on the Website constitutes copyright infringement, please email an infringement claim with DML
        through:
      </p>
      <div class="my-3">
        <p class="gray-text">
          <strong>
            Subject:
          </strong>
          Attention – DML infringement claim
        </p>

        <p class="gray-text">
          <strong>
            Email:
          </strong>
          <a href="mailto:hello@djmixinglab.com">
            hello&#64;djmixinglab.com
          </a>
        </p>
      </div>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Enforcement of These Terms.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        DML reserves the right to enlist and take measures that DML believes are reasonably necessary to enforce, or
        appropriate to enforce, or verify compliance with any part of this T&amp;C (including but not limited to DML’s
        right to cooperate with any legal process relating to your use of the Website and/or Content, and/or a third
        party claim that your use of the Website and/or Content is unlawful and/or infringes such third party’s
        rights). You agree that DML has the right, without liability or notice to you, to disclose any Registration
        Data/Account information to law enforcement authorities, government official, and/or third party, as DML
        believes is reasonably necessary or appropriate to enforce and/or verify compliance with any part of this
        T&amp;C (including but not limited to DML’s right to cooperate with any legal process relating to your use of
        the Website and/or Content, and/or a third party claim that your use of the Website and /or Content is
        unlawful and/or infringes such third party’s rights).
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            No Responsibility for Third-Party Materials or Web Sites.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        The Website may include Products, Content, and services from third parties available via the Website. DML
        may include links to third party websites, which are provided solely as a convenience to you. DML assumes no
        liability or responsibility for third-party materials or websites, and you acknowledge and agree that DML is
        not responsible for evaluating or examining the content or accuracy of any such third-party material or
        websites.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Indemnity and Waiver.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        By using the Website you agree to defend, indemnify and hold harmless DML and its agents, employees,
        directors, contractors, representatives, licensors, technology providers, affiliates, parents and
        subsidiaries from and against any and all claims, losses, demand, causes of action and judgments (including
        attorney’ fees and court costs) arising from or concerning your breach of this T&amp;C and your use of the
        Website or the Content and to reimburse them on demand for any losses, costs or expenses they incur as a
        result thereof. You shall not sue or seek to recover any damages or other payment from DML and its agents,
        representatives, employees, Licensors, affiliates, content and technology providers, and any parent or
        subsidiary company as a result of its decision to terminate or suspend the T&amp;C and service hereunder.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Disclaimers and Limitations of Liability.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        You agree that from time to time DML may remove the Website, or portions of the Website, for indefinite
        periods of time, or cancel the Website, or portions of the Website, at any time, with or without notice to
        you.
      </p>

      <p class="gray-text">
        DML makes no warranty that any particular CD burner, browser, or portable device will be compatible with the
        Website or any Content offered on the Website.
        Under no circumstance shall DML be liable for any unauthorized use of the Website or its Content.
      </p>

      <p class="gray-text">
        To the extent that in a particular circumstance any disclaimer or limitation on damages or liability set forth herein is prohibited by applicable law, then, instead of the provisions hereof in such particular circumstance, DML shall be entitled to the maximum disclaimers and/or limitation on damages and legality available at law or in equity by such applicable law in such particular circumstance, and in no event shall such damages or liability exceed US $10.
      </p>

      <p class="gray-text">
        To the extent that in a particular circumstance any disclaimer or limitation on damages or liability set forth herein is prohibited by applicable law, then, instead of the provisions hereof in such particular circumstance, DML shall be entitled to the maximum disclaimers and/or limitation on damages and legality available at law or in equity by such applicable law in such particular circumstance, and in no event shall such damages or liability exceed US $10.
      </p>

      <p class="gray-text">
        All Content on this Website is provided to you on an “as is” “as available” basis without warranty of any kind either express or implied, including but not limited to the implied warranties of merchantability, fitness for a particular purpose, and non-infringement. DML makes no warranty as to the accuracy, completeness, currency, or reliability of any content available through the website. You are responsible for verifying any information before relying on it. Use of the Website and the Content available on the Website is at your sole risk. DML makes no representations or warranties that use of the website will be uninterrupted or error-free. You are responsible for taking all necessary precautions to ensure that any content you may obtain from the Website is free of viruses.
      </p>

      <p class="gray-text">
        EXCLUSION OF INCIDENTAL, CONSEQUENTIAL AND CERTAIN OTHER DAMAGES. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL DML OR ITS SUPPLIERS BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT, OR CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS OR CONFIDENTIAL OR OTHER INFORMATION, FOR BUSINESS INTERRUPTION, FOR PERSONAL INJURY, FOR LOSS OF PRIVACY, FOR FAILURE TO MEET ANY DUTY INCLUDING OF GOOD FAITH OR OF REASONABLE CARE, FOR NEGLIGENCE, AND FOR ANY OTHER PECUNIARY OR OTHER LOSS WHATSOEVER) ARISING OUT OF OR IN ANY WAY RELATED TO THE USE OF OR INABILITY TO USE THE SOFTWARE, THE PROVISION OF OR FAILURE TO PROVIDE SUPPORT SERVICES, OR OTHERWISE UNDER OR IN CONNECTION WITH ANY PROVISION OF THIS T&amp;C, EVEN IN THE EVENT OF THE FAULT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, BREACH OF CONTRACT OR BREACH OF WARRANTY OF
        <a routerLink="/">DJMIXINGLAB.COM</a> OR ANY SUPPLIER, AND EVEN IF <a routerLink="/">DJMIXINGLAB.COM</a> OR ANY SUPPLIER HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Termination/Cancellation.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        DML may, at its discretion, modify, suspend, or discontinue the Website (or any part or content thereof) at any time with or without notice to you, and DML will not be liable to you or to any third party should it exercise such rights. No refunds will be issued in such cases.
      </p>

      <p class="gray-text">
        If you fail, or DML suspects that you have failed, to comply with any of the provisions of this T&amp;C, including but not limited to: failure to make payment of fees due, failure to provide DML with a valid credit card or with accurate and complete Registration Data, failure to safeguard your Account information, using your Account for activities DML believes violate the intentions or integrity of its platform including violation of a third party’s intellectual property rights and squatting usernames or accounts, as well as using explicit language or indecent photographs/videos in any profiles, or any other violation of this T&amp;C, DML, at its sole discretion, without notice to you may: (i) terminate this T&amp;C and /or your Account, and you will remain liable for all amounts due under your Account up to and including the date of termination; and/or (ii) preclude your access to the Website (or any part thereof), and seek any other lawful remedy available.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Export Controls.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        The Content offered by DML may be subject to U.S. export and control laws and regulations.
      </p>

      <p class="gray-text">
        You warrant that you are (1) not located in Cuba, Iran, North Korea, Sudan, or Syria, and (2) are not a denied party as specified in the regulations listed above. You agree to comply with all applicable export and re-export control laws and regulations. Specifically, you agree that you shall not – directly or indirectly – sell, export, re-export, transfer, divert, or otherwise dispose of any products, software, or technology (including products derived from or based on such technology) received from DML under these T&amp;Cs to any destination, entity, or person prohibited by the laws or regulations of the United States, without obtaining prior authorization from the competent government authorities as required by those laws and regulations. This export control clause shall survive termination or cancellation of these T&amp;Cs.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Governing Law.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        The laws of the State of Nevada, of the United States of America, excluding its conflicts of law rules, govern this T&amp;C and your use of the Website. Your use of the Website may also be subject to other local, state, national, or international laws. You expressly agree that exclusive jurisdiction for any claim or dispute with DML or relating in any way to your use of the Website resides in the courts of the State of Nevada, U.S.A.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <li>
          <strong>
            Contact Us.
          </strong>
        </li>
      </p>
      <p class="gray-text">
        If you have any questions, concerns and suggestions about this document, please contact us at:
        <a href="mailto:hello@djmixinglab.com">
          hello&#64;djmixinglab.com
        </a>
      </p>
    </div>
  </ol>
</div>
